import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { SITE, NAV_LINKS } from "../../config/site";

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const close = () => setOpen(false);

  return (
    <header className="sticky top-0 z-50 border-b border-[#27272A] bg-[#050505]/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6">
        <Link
          to="/"
          onClick={close}
          data-testid="header-logo-link"
          className="focus-gold flex items-center gap-3"
        >
          <img
            src="/brand/cab-mark.svg"
            alt=""
            aria-hidden="true"
            className="h-10 w-10 shrink-0"
          />
          <span className="leading-tight">
            <span className="block font-serif text-base font-semibold tracking-wide text-white sm:text-lg">
              {SITE.name}
            </span>
            <span className="block text-[11px] uppercase tracking-[0.2em] text-[#D4AF37]">
              £100 Fixed Fare
            </span>
          </span>
        </Link>

        <nav aria-label="Main navigation" className="hidden items-center gap-7 lg:flex">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              data-testid={`nav-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `focus-gold text-sm tracking-wide transition-colors duration-150 ${
                  isActive ? "text-[#D4AF37]" : "text-[#A1A1AA] hover:text-white"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
          <Link
            to="/book"
            data-testid="nav-request-journey-cta"
            className="focus-gold border border-[#D4AF37] bg-[#D4AF37] px-5 py-2.5 text-sm font-semibold uppercase tracking-wider text-black transition-colors duration-150 hover:bg-[#E5C158]"
          >
            Request a £100 Journey
          </Link>
        </nav>

        <button
          type="button"
          data-testid="mobile-menu-toggle"
          aria-expanded={open}
          aria-controls="mobile-nav"
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen((v) => !v)}
          className="focus-gold p-2 text-white lg:hidden"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <nav
          id="mobile-nav"
          aria-label="Mobile navigation"
          className="border-t border-[#27272A] bg-[#050505] px-4 pb-6 pt-2 lg:hidden"
        >
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              onClick={close}
              data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `focus-gold block border-b border-[#1A1A1A] py-3.5 text-base ${
                  isActive ? "text-[#D4AF37]" : "text-[#A1A1AA]"
                } ${location.pathname === link.to ? "text-[#D4AF37]" : ""}`
              }
            >
              {link.label}
            </NavLink>
          ))}
          <Link
            to="/book"
            onClick={close}
            data-testid="mobile-nav-request-journey-cta"
            className="focus-gold mt-4 block border border-[#D4AF37] bg-[#D4AF37] px-5 py-3.5 text-center text-sm font-semibold uppercase tracking-wider text-black"
          >
            Request a £100 Journey
          </Link>
        </nav>
      )}
    </header>
  );
}
